/** Angular */
import { Injectable } from '@angular/core';
/** Rxjs */
import { Observable } from 'rxjs';
/** Models */
import { DsChartData } from './classes/chart-data.class';
import { BydModel } from '@sixense/byd-core-service';
/** Services */
import { BydRhsAbstractService } from '../../shared/services/byd-rhs-abstract.service';

@Injectable({
  providedIn: 'root',
})
export class DsDashboardService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Get datas to inject to chart, datas are the states on each forms instances.
   *
   * @param projectId Project ID
   * @param param the param
   * @returns Observable<BydModel<DsChartData>>
   */
  public getDashboardFormsInstancesStates(projectId: number, param?: string): Observable<BydModel<DsChartData>> {
    this.path = `/projects/${projectId}/dashboards/forms/instances/states`;
    if (param !== undefined) {
      this.path += `?filter=${param}`;
    }
    return this.getModels<DsChartData>();
  }

  /**
   * Get datas to inject to chart, datas are the states on each field of these instances.
   *
   * @param projectId Project ID
   * @param formId Form ID
   * @returns Observable<BydModel<DsChartData>>
   */
  public getDashboardFormsInstancesFieldsStates(projectId: number, formId: number): Observable<BydModel<DsChartData>> {
    this.path = `/projects/${projectId}/dashboards/forms/${formId}/fields/states`;
    return this.getModels<DsChartData>();
  }

  /**
   * Get datas to inject to chart, for all organisation's projects,
   * datas are the states on each forms instances.
   *
   * @param organisationId Organisation's id
   * @returns Observable<BydModel<DsChartData>>
   */
  public getOrganisationDashboardFormsInstancesStates(organisationId: number): Observable<BydModel<DsChartData>> {
    this.path = `/organisations/${organisationId}/dashboards/forms/instances/states`;
    return this.getModels<DsChartData>();
  }

  /**
   * Get datas to inject to chart, separate organisation's projects,
   * datas are the states on each forms instances.
   *
   * @param organisationId Organisation's id
   * @returns Observable<BydModel<DsChartData>>
   */
  public getOrganisationDashboardFormsInstancesStatesPerProject(
    organisationId: number
  ): Observable<BydModel<DsChartData>> {
    this.path = `/organisations/${organisationId}/dashboards/forms/instances/states?type=separate`;
    return this.getModels<DsChartData>();
  }

  /**
   * Create DsChartData instance.
   *
   * @param  jsonObject The flat json object.
   * @returns an `DsChartData` instance.
   */
  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public createNewInstance(jsonObject: any): DsChartData {
    return new DsChartData(jsonObject);
  }
}
